import { Deserializable } from '../deserializable';
import {Staffs} from '../staff/staffs';


export  class LogViewItem implements Deserializable
{
  public id: number;
  public staff: Staffs;
  public createdDate: Date;

  deserialize(input: any): this {
    Object.assign(this, input);
    this.staff = input.staff != null ?  new Staffs().deserialize(input.staff) : null;
    return this;
  }
}
